import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {OphPageHeaderComponent} from './../../shared/design/oph-page-header/oph-page-header.component';
import {TeamDialogComponent, TeamDialogData} from '../team-dialog/team-dialog.component';
import {TEAM_DIALOG_SETTINGS} from '../utils/teams.constants';
import {Team} from '../shared/model/team';
import {MobileService} from 'src/app/core/page/mobile.service';

@Component({
  selector: 'teams-header',
  standalone: true,
  imports: [OphPageHeaderComponent],
  templateUrl: './teams-header.component.html',
  styleUrl: './teams-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamsHeaderComponent {
  private readonly mobileService = inject(MobileService);
  private dialog = inject(MatDialog);
  allTeams = input<Team[]>();
  searchValueChange = output<string>();

  addTeam(): void {
    this.dialog.open(TeamDialogComponent, {
      data: {team: null, teams: this.allTeams()} as TeamDialogData,
      ...TEAM_DIALOG_SETTINGS,
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
    });
  }

  onSearchChange(searchValue: string): void {
    this.searchValueChange.emit(searchValue);
  }
}
